import { useEffect, useRef } from 'react';

/**
 * Custom hook for detecting clicks outside of a referenced element
 * @param {React.RefObject} ref - The ref object for the element to detect outside clicks
 * @param {Function} handler - The callback function to execute when clicking outside
 */
export function useClickOutside(ref, handler) {
  const savedHandler = useRef(handler);

  useEffect(() => {
    savedHandler.current = handler;
  }, [handler]);

  useEffect(() => {
    const listener = (event) => {
      const el = ref?.current;
      
      // Do nothing if clicking ref's element or descendent elements
      if (!el || el.contains(event.target)) {
        return;
      }
      
      savedHandler.current(event);
    };

    document.addEventListener('mousedown', listener, { capture: true });
    document.addEventListener('touchstart', listener, { capture: true });
    document.addEventListener('pointerdown', listener, { capture: true });

    return () => {
      document.removeEventListener('mousedown', listener, { capture: true });
      document.removeEventListener('touchstart', listener, { capture: true });
      document.removeEventListener('pointerdown', listener, { capture: true });
    };
  }, [ref]);
}